import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const Logout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        Cookies.remove('hcStaff');
        localStorage.removeItem('user');
        localStorage.removeItem('userType');
        navigate('/staff/login');
    }, [navigate]);

    return (
        <div>Logging out...</div>
    );
};

export default Logout;
